import './Shop.scss'
import './VoucherPage.scss'

import React, {Component} from 'react'
import moment from 'moment'

import leftArrow from '../imgs/order-calendar-left-arrow.svg'
import rightArrow from '../imgs/order-calendar-right-arrow.svg'
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import RangeSelector from '../components/RangeSelector';

import { push } from 'connected-react-router'

import { apiUrl, loadOffersRange } from '../api'

import vouchPreviewImage from '../imgs/voucher-preview.png'

import lodash from 'lodash';

class VoucherPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            text: props.voucherText || '',
            name: props.voucherName || '',
            amount: (props.match.params.voucherValue && parseInt(props.match.params.voucherValue)) || props.voucherAmount,
            offersRange: []
        }

        console.log(props)
    }

    drawLines(context, text, maxWidth) {
        var words = text.split(" ");
        var lines = [];
        var currentLine = words[0];

        for (var i = 1; i < words.length; i++) {
            var word = words[i];
            var width = context.measureText(currentLine + " " + word).width;
            if (width < maxWidth) {
                currentLine += " " + word;
            } else {
                lines.push(currentLine);
                currentLine = word;
            }
        }
        lines.push(currentLine);

        for (var i = 0; i < lines.length; i++) {
            context.fillText(lines[i], 0, (i + 1) * 10);
        }
    }

    drawCenteredText(context, text, width) {       
        const textWidth = context.measureText(text).width;
        context.fillText(text, (width - textWidth) / 2 , 0);
    }

    drawVoucher() {
        const props = this.props;
        const canvas = this.refs.previewCanvas;
        const box = canvas.getBoundingClientRect();
        canvas.width = box.width;
        canvas.height = box.width / 1.4139;

        const context = canvas.getContext("2d");

        context.msImageSmoothingEnabled = true;
        context.imageSmoothingEnabled = true;
        context.mozImageSmoothingEnabled = true;

        context.fillStyle = '#ffffff';
        context.fillRect(0,0,canvas.width,canvas.height);
        context.fillStyle = '#ffffff';
        context.font = "6pt CeraPro";

        if (this.voucherPreviewImage) {
            const scale = canvas.width / this.voucherPreviewImage.width;

            context.save();
            context.scale(scale, scale);
            context.drawImage(this.voucherPreviewImage, 0, 0);
            context.restore();
        }

        context.save();
        context.translate(65, 260);
        this.drawLines(context, this.state.text, 170);
        context.restore();

        context.save();
        context.translate(300, 230);
        context.font = "8pt CeraPro-Bold";

        if (props.vehicleType && props.trainingType) {
            this.drawCenteredText(context,  props.vehicleType.name + " " + props.trainingType.name, 220);    
        }
        
        context.restore();

        if (this.state.amount) {
            context.save();
            context.translate(300, 254);
            this.drawCenteredText(context, this.state.amount + " €", 220);
            context.restore();
        }

        context.save();
        context.translate(300, 274);
        this.drawCenteredText(context, this.state.name, 220);
        context.restore();

        context.save();
        context.translate(300, 293.5);
        this.drawCenteredText(context, moment().format('DD.MM.YYYY'), 220);
        context.restore();

        context.save();
        context.translate(300, 313.8);
        this.drawCenteredText(context, moment().format('YYMMDD')+'-XXXXXX', 220);
        context.restore();

        context.save();
        context.translate(300, 334.7);
        this.drawCenteredText(context, 'XXXXXXXXXXXX', 220);
        context.restore();
    }

    componentDidMount() {
        this.drawVoucher()
        this.voucherPreviewImage = new Image();
        this.voucherPreviewImage.src = vouchPreviewImage;
        this.voucherPreviewImage.addEventListener("load", () => {
            this.drawVoucher();
        });

        loadOffersRange().then(data => {
            this.setState({
                'offersRange': data
            })
        });
    }

    componentDidUpdate() {
        this.drawVoucher()
    }

    render() {
        const props = this.props;

        return (
            <article className={"shop-page page"}>
        <form onSubmit={(e) => {
            e.preventDefault()
            this.props.next(this.state.amount, this.state.text, this.state.name)
        }}>

        <section className="section gray-section">
            <div className="section-content">
                <div className="container">
                <h1 className="text-center shop-title">Gutschein personalisieren</h1>
                    <div className="shop shop-voucher">
                <div className="shop-content">
                    <label className="label-grid">
                        <span className="label-text">Für</span>
                        <div className="label-control">
                            <input 
                                className="input input--fullwidth" 
                                maxLength={100}
                                value={this.state.name}
                                onChange={(e) => this.setState({name: e.target.value})}  
                            />
                        </div>
                    </label>
                    <label className="label-grid">
                        <span className="label-text">Persönliche Nachricht</span>
                        <div className="label-control">
                            <textarea 
                                className="textarea textarea--fullwidth" 
                                rows="3"
                                maxLength={200}
                                value={this.state.text}
                                onChange={(e) => this.setState({text: e.target.value})}  
                            ></textarea>
                            <div className="label-help">
                                Hinweis: Maximal 200 Zeichen. Wenn sie keine Persönliche Nachricht integrieren wollen, bitte das Feld frei lassen.
                            </div>
                        </div>
                    </label>
                    <label className="label-grid">
                        <span className="label-text">Designvorschau</span>
                        <div className="label-control">
                            <canvas ref="previewCanvas" className="voucher-preview">
                            </canvas>
                        </div>
                    </label>
                </div>
                <div className="shop-sidebar">
                    <div className="shop-sidebar-container">
                    <header className="shop-sidebar-header">
                        <h1 className="shop-sidebar-title">Auswahl</h1>
                    </header>
                    <div className="shop-sidebar-content">
                        <h2 className="shop-sidebar-content-title">Gutschein {(!props.vehicleType || !props.trainingType) && ("Freibetrag")}</h2>
                        <div>
                            <label className="label-grid label-grid--sidebar">
                                <span className="label-text">Betrag:</span>
                                <div className="label-content">
                                    {props.vehicleType && props.trainingType && (
                                    <span>{parseInt(this.state.amount)} €</span>
                                    )}
                                    {(!props.vehicleType || !props.trainingType) && (
                                    <div className="input-container">
                                        <input type="number" className="input input--currency" 
                                            required
                                            min="5"
                                            max="200"
                                            placeholder=""
                                            value={this.state.amount || ''} 
                                            onChange={(e) => this.setState({amount: parseFloat(e.target.value)})} 
                                        />
                                        <span className="input-symbol">€</span>
                                    </div>
                                    )}
                                </div>
                            </label>
                            {props.vehicleType && (
                            <label className="label-grid label-grid--sidebar">
                                <span className="label-text">Fahrzeug:</span>
                                <div className="label-content">
                                    {props.vehicleType.name}
                                </div>
                            </label>
                            )}
                            {props.trainingType && (
                            <label className="label-grid label-grid--sidebar">
                                <span className="label-text">Training:</span>
                                <div className="label-content">
                                    {props.trainingType.name}
                                </div>
                            </label>
                            )}
                        </div>
                    </div>
                    <footer className="shop-sidebar-footer">
                        <table className="order-table" style={{width: '100%'}}>
                            <tbody>
                                <tr>
                                    <td>Einzelposten</td>
                                    <td style={{textAlign: 'right'}}>{(this.state.amount || 0).toFixed(2)} €</td>
                                </tr>
                                <tr>
                                    <th style={{textAlign: 'left'}}>Zwischensumme:</th>
                                    <td style={{textAlign: 'right'}}>{(this.state.amount || 0).toFixed(2)} €</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            <button 
                                type="button"
                                className="btn"
                                onClick={() => this.props.gotoShop()}
                                >Zurück
                            </button>
                            {(
                            <button 
                                className="btn right" 
                                style={{float: 'right'}}
                                type="submit"
                                >Weiter
                            </button>
                            )}
                        </p>
                    </footer>
                    </div>
                </div>
            </div>
                </div>
            </div>
        </section>
        </form>
        </article>
        )
    }
}

const mapStateToProps = (state, props) => {
    console.log('state', state)

  return {
    vehicleType: state.shop.vehicleTypes && state.shop.vehicleTypes[props.match.params.vehicleTypeId],
    trainingType: state.shop.trainingTypes && state.shop.trainingTypes[props.match.params.trainingTypeId],
    voucherText: state.order.voucherText,
    voucherName: state.order.voucherName,
    voucherAmount: state.order.voucherAmount
  }
}

const mapDispatchToProps = dispatch => {
  return {
    gotoShop: () => dispatch(push('/shop/')),
    next: (amount, text, name) => {
        dispatch({type: 'VOUCHER_UPDATE', kind: 'amount', amount: parseInt(amount), text: text, name: name})
        dispatch(push('/bestellung/rechnungsinformationen/'))
    }
  }
}

export default withRouter(connect(
    mapStateToProps, 
    mapDispatchToProps
)(VoucherPage))


// WEBPACK FOOTER //
// ./src/pages/VoucherPage.jsx